import { addItemToWorkflowTable, removeItemFromWorkflowTable } from '@/warehouse/helpers';
export function updateVerificationItemsByMessage(draft, message) {
    const { pickingItem } = message;
    const itemIndex = draft.findIndex((item) => item.id === pickingItem.id);
    const shouldNotExits = pickingItem.quantity - pickingItem.pickedQuantity - pickingItem.blockedQuantity === 0;
    const shouldBeRemoved = shouldNotExits && itemIndex !== -1;
    const shouldBeAdded = !shouldNotExits && itemIndex === -1;
    if (shouldBeRemoved) {
        removeItemFromWorkflowTable(draft, itemIndex);
    }
    else if (shouldBeAdded) {
        addItemToWorkflowTable(draft, { ...pickingItem, stockName: message.task.stockName }, 'id');
    }
    else {
        draft[itemIndex].quantity = pickingItem.quantity;
        draft[itemIndex].pickedQuantity = pickingItem.pickedQuantity;
        draft[itemIndex].blockedQuantity = pickingItem.blockedQuantity;
    }
}
